<script setup>
import { computed } from 'vue';
import { formataMoedaReais } from '@kodatec/brasil-utils';

const props = defineProps({
    solicitacao: {
        type: Object,
        required: true
    }
})

// Monta o rótulo de uma conta a partir de um prefixo de campos nos dados da solicitação.
const rotuloConta = (prefixo) => {
    const dados = props.solicitacao.dados || {};
    const banco = dados[`${prefixo}_banco_nome`];
    const agencia = dados[`${prefixo}_agencia`];
    const agenciaDv = dados[`${prefixo}_agencia_dv`];
    const conta = dados[`${prefixo}_conta`];
    const contaDv = dados[`${prefixo}_conta_dv`];
    const operacao = dados[`${prefixo}_operacao`];

    if (!banco && !conta) return null;

    const agenciaTexto = agencia ? `Agência ${agenciaDv ? `${agencia}-${agenciaDv}` : agencia}` : '';
    const contaTexto = conta ? `Conta ${contaDv ? `${conta}-${contaDv}` : conta}` : '';
    const operacaoTexto = operacao ? `Operação ${operacao}` : '';
    const detalhe = [agenciaTexto, contaTexto, operacaoTexto].filter(Boolean).join(', ');

    return { banco: banco || 'Conta', detalhe };
};

const contaOrigem = computed(() => rotuloConta('projeto_conta_bancaria_origem'));
const contaDestino = computed(() => rotuloConta('projeto_conta_bancaria_destino'));
</script>

<template>
    <h3 class="text-900 font-bold text-sm mb-3 col-12">Dados da Solicitação</h3>

    <LabelDados titulo="Conta de Origem" v-if="contaOrigem" :conteudo="contaOrigem.banco"
        :detalhe="contaOrigem.detalhe" />

    <LabelDados titulo="Conta de Destino" v-if="contaDestino" :conteudo="contaDestino.banco"
        :detalhe="contaDestino.detalhe" />

    <LabelDados titulo="Valor"
        :conteudo="props.solicitacao.dados.valor ? formataMoedaReais(props.solicitacao.dados.valor) : 'Não informado'" />

    <LabelDados titulo="Justificativa" v-if="props.solicitacao.dados.justificativa"
        :conteudo="props.solicitacao.dados.justificativa" tamanho_div="col-12" />
</template>
